module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daycloud-66ca1933047188b18f06b6e6c1c551a7.svg";